import React from 'react'
import Button from '../../Components/Button/Button'
import './AppBanner.css'
import AssetImage from '../../Helper/AssetImage'
import AssetImages from '../../Helper/AssetImages'
import goToLink from '../../Helper/GoToLink'
import GoToLinks from '../../Data/GoToLinks'

export default function AppBanner() {
    return (
        <div className='app-banner section  res-gap-32'>
            <div className='header container-vertical res-gap-24 justify-content-right'>
                <h4 className='clr-grey-100 text-align-right'>
                    <mark>Download our App</mark> <br />
                    for the best Trading Experience
                </h4>
                <Button name='Download App' onClick={() =>  goToLink(GoToLinks.downloadAppLink)} />
            </div>
            <div className='banner-img-container'>
                <AssetImage assetImage={AssetImages.imageDownloadAppBanner} />
            </div>
        </div>
    )
}
